import { render, staticRenderFns } from "./capitalAccountInitDetail.vue?vue&type=template&id=136fe273"
import script from "./capitalAccountInitDetail.vue?vue&type=script&lang=js"
export * from "./capitalAccountInitDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports